export function sortArrObj(data, property, asc) {
  // data is going to be array of object
  // property is according to which property of object,  array should be sorted
  // asc is boolean true means sort in ascending order.

  // suppose we have array like

  /**
     const dummyData = [
      { name: "ramesh2", score: 9, avgScore: 5 },
      { name: "ramesh1", score: 11, avgScore: 8 },
      { name: "ramesh3", score: 6, avgScore: 3 },
    ];

    dummyData.sort((a, b) => {
      return b.avgScore - a.avgScore;
    });
   */

  // console.log("running SortArrobj");
  // console.log(property);
  if (property == "name") {
    data.sort((a, b) => {
      // console.log(a[property] > b[property]);
      if (a[property] > b[property]) return 1;
      else if (a[property] < b[property]) return -1;
      else return 0;
    });
  } else {
    if (asc) {
      data.sort((a, b) => {
        // console.log(a[property] - b[property]);
        return a[property] - b[property];
      });
    } else {
      data.sort((a, b) => {
        // console.log(b[property] - a[property]);
        return b[property] - a[property];
      });
    }
  }

  return data;
}
